(() => {
  const ready = () => {
    window.setTimeout(() => document.documentElement.classList.add('page-ready'), 180);

    const revealItems = document.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
      revealItems.forEach((item, index) => {
        item.style.transitionDelay = `${Math.min(index % 4, 3) * 80}ms`;
        observer.observe(item);
      });
    } else {
      revealItems.forEach((item) => item.classList.add('is-revealed'));
    }

    const header = document.querySelector('[data-header]');
    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY;
      if (header) header.classList.toggle('is-sticky', y > 180 && y < lastY);
      lastY = y;

      const parallax = document.querySelector('[data-parallax]');
      if (parallax && y < window.innerHeight && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        parallax.style.transform = `translate3d(0, ${y * 0.12}px, 0) scale(1.05)`;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    const glow = document.querySelector('.pointer-glow');
    if (glow && matchMedia('(pointer:fine)').matches) {
      window.addEventListener('pointermove', (event) => {
        glow.style.transform = `translate3d(${event.clientX - 210}px, ${event.clientY - 210}px, 0)`;
      }, { passive: true });
    }

    document.querySelectorAll('.magnetic').forEach((button) => {
      if (!matchMedia('(pointer:fine)').matches) return;
      button.addEventListener('pointermove', (event) => {
        const box = button.getBoundingClientRect();
        const x = (event.clientX - box.left - box.width / 2) * 0.14;
        const y = (event.clientY - box.top - box.height / 2) * 0.14;
        button.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      });
      button.addEventListener('pointerleave', () => { button.style.transform = ''; });
    });

    document.querySelectorAll('[data-tilt]').forEach((card) => {
      if (!matchMedia('(pointer:fine)').matches) return;
      card.addEventListener('pointermove', (event) => {
        const box = card.getBoundingClientRect();
        const x = (event.clientX - box.left) / box.width - 0.5;
        const y = (event.clientY - box.top) / box.height - 0.5;
        card.style.transform = `perspective(900px) rotateX(${-y * 2.5}deg) rotateY(${x * 2.5}deg)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });

    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        menu.classList.toggle('is-open', !open);
        document.body.classList.toggle('menu-open', !open);
      });
    }

    const slider = document.querySelector('[data-quotes]');
    if (slider) {
      const quotes = [...slider.querySelectorAll('.quote')];
      const count = slider.querySelector('[data-quote-count]');
      let active = 0;
      const show = (index) => {
        active = (index + quotes.length) % quotes.length;
        quotes.forEach((quote, i) => quote.classList.toggle('is-active', i === active));
        if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(quotes.length).padStart(2, '0')}`;
      };
      slider.querySelector('[data-quote-prev]')?.addEventListener('click', () => show(active - 1));
      slider.querySelector('[data-quote-next]')?.addEventListener('click', () => show(active + 1));
      if (quotes.length > 1) window.setInterval(() => show(active + 1), 7500);
      show(0);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
